"use strict";
var charAt = require("../internals/string-multibyte").charAt;
var toString = require("../internals/to-string");
var InternalStateModule = require("../internals/internal-state");
var defineIterator = require("../internals/iterator-define");
var createIterResultObject = require("../internals/create-iter-result-object");
var STRING_ITERATOR = "String Iterator";
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
defineIterator(String, "String", function(iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(void 0, true);
  point = charAt(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});
